import { subDays } from 'date-fns';
import { InitialDateRange } from './DateRangePicker.types';

export const initialDateRange: InitialDateRange = {
    startDate: subDays(new Date(), 30),
    endDate: subDays(new Date(), 1),
    buttonLabel: 'Last30Days',
};
